const styles = {
  mainButtom: {
    width: '200px',
    '& svg': {
      fill: '#fff!important',
    },
  },
  field: {
    mb: 1,
  },

}

export default styles
